import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const BrandingHeader = () => {
  return (
    <div className="text-center mb-6 md:mb-8">
      <Link to="/login" className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl mb-4 md:mb-6 transition-all duration-250 hover:opacity-90 bg-primary">
        <Icon name="/assets/images/Untitled-1768978080610.jpeg" size={32} />
      </Link>
      
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground mb-2">
        Welcome to Videra
      </h1>
      
      <p className="text-sm md:text-base text-muted-foreground font-caption">
        Adaptable Tissue Marker
      </p>
    </div>
  );
};

export default BrandingHeader;